import { CheckoutCardProvider } from './checkout-card-provider.enum';

export interface BaseCheckoutCardConfig {
  provider: CheckoutCardProvider;
}
